<template>
  <div class="card-body meters">
    <!-- Status Dot -->
    <div v-if="!activeMeterInfo.Removed" class="dot-active float-right"></div>
    <div v-else class="dot float-right"></div>
    <div class="all_meter_info mt-3" v-if="activeMeterInfo && activeConfigInfo">
      <!-- Meter Serial -->
      <div class="meter serial pb-2">
        <h6 class="d-inline-block pr-2">Meter Serial:</h6>
        <p class="d-inline-block">{{activeMeterInfo.Serial}}</p>
      </div>
      <div>
        <img src="@/assets/img/barcode.png" class="img-fluid pb-2" alt="Barcode" />
      </div>
      <!-- Meter Type -->
      <div class="meter_info">
        <div class="mb-3 p-1 bg-white d-flex align-items-center">
          <div class="d-inline-block left">
            <p class="font-weight-bold">Meter Type:</p>
          </div>
          <div class="d-inline-block right">
            <p class="text-capitalize">H</p>
          </div>
        </div>
        <!-- Automated Readings -->
        <div class="mb-3 p-1 bg-white">
          <div class="d-inline-block left">
            <p class="font-weight-bold">Automated Readings:</p>
          </div>
          <div class="d-inline-block right">
            <p>True</p>
          </div>
        </div>
        <!-- Install Date -->
        <div class="mb-3 p-1 bg-dark text-white d-flex align-items-center">
          <div class="d-inline-block left">
            <p class="font-weight-bold">Install Date:</p>
          </div>
          <div class="d-inline-block right">
            <p v-if="activeMeterInfo.Installed">{{activeMeterInfo.Installed | shortDate}}</p>
            <p v-else>N/A</p>
          </div>
        </div>
        <!-- Removed Date -->
        <div class="mb-3 p-1 bg-dark text-white d-flex align-items-center">
          <div class="d-inline-block left">
            <p class="font-weight-bold">Removed Date:</p>
          </div>
          <div class="d-inline-block right">
            <p v-if="activeMeterInfo.Removed">{{activeMeterInfo.Removed | shortDate}}</p>
            <p v-else>N/A</p>
          </div>
        </div>
        <!-- Last Actual Advance -->
        <div class="mb-3 p-1 bg-dark text-white d-flex align-items-center">
          <div class="d-inline-block left">
            <p class="font-weight-bold text-white">Last Actual Advance:</p>
          </div>
          <div class="d-inline-block right">
            <p
              v-if="activeMeterInfo.LastAdvance"
            >{{activeMeterInfo.LastAdvance | shortDate}}</p>
            <p v-else>N/A</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { _ } from "vue-underscore";

import elecMetersMixin from "@/mixins/meterInfo/meters/elecMeters.js";

export default {
  name: "electricityMeterHh",
  mixins: [elecMetersMixin]
};
</script>